import ApiService from "@/core/services/api.service";

const url = process.env.VUE_APP_API_ADMIN;

class KauflandSubscriptions {
  create() {
    return ApiService.post(url + "/kaufland/subscriptions", {});
  }
}

export default new KauflandSubscriptions();
